module.exports = __webpack_public_path__ + "img/axXez_Logo.c5952d63.png";